import React from 'react';
import { useTranslation } from 'react-i18next';

export default function RecordInfos({ selectedCoal, fullScreen = false }) {
    const { t } = useTranslation();

    if (fullScreen) {
        return (
            <div className='row'>
                <div className='row'>
                    <div className='col-4'><p>{t('glossario.taxonomias.familia')}: {selectedCoal.family ? selectedCoal.family.name : ''}</p></div>
                    <div className='col-4'><p>{t('carvão.subFamilia')}: {selectedCoal.sub_fam || ''}</p></div>
                    <div className='col-4'><p>{t('glossario.taxonomias.genero')}: {selectedCoal.genus ? selectedCoal.genus.name : ''}</p></div>
                </div>
                <div className='row'>
                    <div className='col-4'><p>{t('glossario.taxonomias.especie')}: {selectedCoal.species ? selectedCoal.species.name : ''}</p></div>
                    <div className='col-4'><p>{t('carvão.determinação')}: {selectedCoal.determination || ''}</p></div>
                    <div className='col-4'><p>{t('carvão.sítio')}: {selectedCoal.site ? selectedCoal.site.name : ''}</p></div>
                </div>
                <div className='row'>
                    <div className='col-12'><p>{t('carvão.procedência')}: {selectedCoal.origin || ''}</p></div>
                </div>
                <div className='row'>
                    <div className='col-4'><p>{t('carvão.código')}: {selectedCoal.code || ''}</p></div>
                    <div className='col-4'><p>{t('carvão.localização')}: {selectedCoal.locale || ''}</p></div>
                    <div className='col-4'><p>{t('carvão.fichaNum')}: {selectedCoal.id}</p></div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        {selectedCoal.type == 1 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.arqueologicos')}</p>}
                        {selectedCoal.type == 2 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.lenhosReferencia')}</p>}
                        {selectedCoal.type == 3 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.literatura')}</p>}
                    </div>
                    <div className='col-4'><p>{t('carvão.autor')}: {selectedCoal.user.name}</p></div>
                </div>
            </div>
        );
    }

    return (
        <div className='row'>
            <div className='row'>
                <div className='col-2 w-50'><p>{t('glossario.taxonomias.familia')}: {selectedCoal.family ? selectedCoal.family.name : ''}</p></div>
                <div className='col-2 w-50'><p>{t('carvão.subFamilia')}: {selectedCoal.sub_fam || ''}</p></div>
            </div>
            <div className='row'>
                <div className='col-2 w-50'><p>{t('glossario.taxonomias.genero')}: {selectedCoal.genus ? selectedCoal.genus.name : ''}</p></div>
                <div className='col-2 w-50'><p>{t('glossario.taxonomias.especie')}: {selectedCoal.species ? selectedCoal.species.name : ''}</p></div>
            </div>
            <div className='row'>
                <div className='col-2 w-50'><p>{t('carvão.sítio')}: {selectedCoal.site ? selectedCoal.site.name : ''}</p></div>
                <div className='col-2 w-50'><p>{t('carvão.determinação')}: {selectedCoal.determination || ''}</p></div>
            </div>
            <div className='row'>
                <div className='col-12'><p>{t('carvão.procedência')}: {selectedCoal.origin || ''}</p></div>
            </div>
            <div className='row'>
                <div className='col-2 w-50'><p>{t('carvão.localização')}: {selectedCoal.locale || ''}</p></div>
                <div className='col-2 w-50'><p>{t('carvão.código')}: {selectedCoal.code || ''}</p></div>
            </div>
            <div className='row'>
                <div className='col-2 w-50'>
                    {selectedCoal.type == 1 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.arqueologicos')}</p>}
                    {selectedCoal.type == 2 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.lenhosReferencia')}</p>}
                    {selectedCoal.type == 3 && <p>{t('carvão.categoria')}: {t('carvão.dropdown.categoria.literatura')}</p>}
                </div>
                <div className='col-2 w-50'><p>{t('carvão.fichaNum')}: {selectedCoal.id}</p></div>
            </div>
            <div className='row'>
                <div className='col-12'><p>{t('carvão.autor')}: {selectedCoal.user.name}</p></div>
            </div>
        </div>
    );
}